import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

//Context
import { AuthContext } from "../../../../common/middlewares/Auth"

// librerias
import { toast } from "react-hot-toast";

//Componentes Material-UI
import {
    Box,
    Card,
    CardActionArea,
    CardHeader,
    Chip,
    Typography,
    CircularProgress,
    Alert,
    AlertTitle,
} from "@mui/material";

//Componentes
import useGetListaDinamica from "../../../../common/hooks/useGetListaDinamica";
import { getRecognitions } from "../../../Reconocimientos/Hooks/trophyService";
import { TRUST_GREEN, resolverPilares, filtrarPorPilar } from "../../../Reconocimientos/pilaresAssets";

const GetTrofeos = () => {
    const navigate = useNavigate();

    const { token, strInfoUser } = useContext(AuthContext);

    const { data: pilaresData } = useGetListaDinamica({
        strGrupo: "Reconocimiento_Motivos",
        strCodigo: "Motivos",
    });
    const pilaresLoading = pilaresData === undefined;
    const pilares = resolverPilares(pilaresData);

    const [recognitions, setRecognitions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const email = strInfoUser?.strEmail;

    const loadRecognitions = useCallback(async () => {
        if (!email || !token) return;
        setLoading(true);
        try {
            const data = await getRecognitions(email, token);
            setRecognitions(data);
            setError(false);
        } catch (err) {
            toast.error(err?.message || "Error al cargar los reconocimientos.");
            setError(true);
        } finally {
            setLoading(false);
        }
    }, [email, token]);

    const refLoadRecognitions = useRef(loadRecognitions);
    refLoadRecognitions.current = loadRecognitions;

    useEffect(() => {
        refLoadRecognitions.current();
    }, [email, token]);

    if (loading || pilaresLoading) {
        return (
            <Box display="flex" justifyContent="center" style={{ paddingTop: 170 }}>
                <CircularProgress color="primary" size={45} />
            </Box>
        );
    }

    if (error) {
        return (
            <Box display="flex" justifyContent="center">
                <Alert severity="error" sx={{ height: "70px" }}>
                    <AlertTitle>Error</AlertTitle>
                    Ha ocurrido un error al momento de cargar los datos de Sala de
                    trofeos.
                </Alert>
            </Box>
        );
    }

    return (
        <Card style={{ height: "100%", display: "flex" }}>
            <CardActionArea
                onClick={() => navigate("/wilson/sala-de-trofeos")}
                sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
                <CardHeader
                    title={<b>Sala de Trofeos</b>}
                    titleTypographyProps={{
                        variant: "subtitle1",
                        gutterBottom: true,
                        align: "center",
                        component: "h5",
                    }}
                />
                <Box
                    sx={{
                        flex: 1,
                        width: "100%",
                        minHeight: 220,
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                    }}
                >
                    {pilares.map((pilar) => {
                        const value = filtrarPorPilar(recognitions, pilar).length;

                        return (
                            <Box
                                key={pilar.codigo}
                                sx={{
                                    flex: 1,
                                    width: "100%",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.5,
                                    px: 1.5,
                                }}
                            >
                                <Box
                                    component="img"
                                    src={pilar.icono}
                                    alt=""
                                    sx={{
                                        width: 100,
                                        height: 100,
                                        objectFit: "contain",
                                        flexShrink: 0,
                                    }}
                                />
                                <Typography
                                    variant="body2"
                                    component="p"
                                    sx={{ flex: 1, minWidth: 0 }}
                                >
                                    {pilar.nombre}
                                </Typography>
                                <Chip
                                    label={value}
                                    sx={{
                                        height: 32,
                                        fontSize: "1.1rem",
                                        background: TRUST_GREEN,
                                        color: "#fff",
                                        fontWeight: 700,
                                    }}
                                />
                            </Box>
                        );
                    })}
                </Box>
            </CardActionArea>
        </Card>
    );
};

export default GetTrofeos;
